import React, { useState, useContext } from "react";
import "./BookCard.css";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faStar } from "@fortawesome/free-solid-svg-icons";
import { faStarHalf } from "@fortawesome/free-solid-svg-icons";
import { Context } from "../context/Context";
import { BasketContext } from "../context/Context";

function BookCard({ src, title, author, prix, rating, desc, id }) {
  const [rate, setRate] = useState(parseInt(rating));
  const [book, setBook] = useContext(Context);
  const [basket, setBasket] = useContext(BasketContext);

  const handleClick = () => {
    setBook({
      ...book,
      src: src,
      title: title,
      author: author,
      prix: prix,
      rating: rating,
      desc: desc,
      id: id,
    });
  };

  const addToBasket = () => {
    setBasket([
      ...basket,
      {
        id: id,
        title: title,
        prix: prix,
        src: src,
        desc: desc,
        rating: rating,
      },
    ]);
  };

  return (
    <div className="bookCard">
      <img
        src={
          src ? src : "https://via.placeholder.com/150x200.png/008000/FFFFFF"
        }
        alt="book cover"
      />
      <div className="bookCard__info">
        <Link to="/BookPreviwe" onClick={handleClick}>
          <h3>{title}</h3>
          <p className="author">{author}</p>
          <div className="rating">
            {rate ? (
              Array(rate)
                .fill()
                .map((_, i) => {
                  return <FontAwesomeIcon icon={faStar} key={i} />;
                })
            ) : (
              <p>rating not availble</p>
            )}
            {rating > rate && rating ? (
              <FontAwesomeIcon icon={faStarHalf} />
            ) : (
              ""
            )}
          </div>
        </Link>
        <div className="btn" onClick={addToBasket}>
          {" "}
          Add to Basket
        </div>
      </div>
    </div>
  );
}

export default BookCard;
